export default [
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'AED',
		to_currency_name: 'United Arab Emirates dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'AUD',
		to_currency_name: 'Australian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'CAD',
		to_currency_name: 'Canadian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'CHF',
		to_currency_name: 'Swiss Franc',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'CNY',
		to_currency_name: 'Chinese Offshore',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'CZK',
		to_currency_name: 'Czech koruna',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'DKK',
		to_currency_name: 'Danish krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'EUR',
		to_currency_name: 'Euro',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'GBP',
		to_currency_name: 'Pound sterling',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'HKD',
		to_currency_name: 'Hong Kong Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'JPY',
		to_currency_name: 'Japanese Yen',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'NOK',
		to_currency_name: 'Norwegian krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'NZD',
		to_currency_name: 'New Zealand dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'PLN',
		to_currency_name: 'Polish zloty',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'SEK',
		to_currency_name: 'Swedish krona',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'SGD',
		to_currency_name: 'Singapore dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'USD',
		to_currency_name: 'US Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'ZAR',
		to_currency_name: 'South African rand',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'BGN',
		to_currency_name: 'Bulgarian lev',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'BHD',
		to_currency_name: 'Bahraini dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'HUF',
		to_currency_name: 'Hungarian forint',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'ILS',
		to_currency_name: 'Israeli new shekel',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'INR',
		to_currency_name: 'Indian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'KWD',
		to_currency_name: 'Kuwaiti dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'MAD',
		to_currency_name: 'Moroccan dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'MUR',
		to_currency_name: 'Mauritian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'RON',
		to_currency_name: 'Romanian leu',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'SAR',
		to_currency_name: 'Saudi riyal',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'GBP',
		from_currency_name: 'Pound sterling',
		to_currency: 'THB',
		to_currency_name: 'Thai baht',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'AED',
		from_currency_name: 'United Arab Emirates dirham',
		to_currency: 'AED',
		to_currency_name: 'United Arab Emirates dirham',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'AUD',
		from_currency_name: 'Australian Dollar',
		to_currency: 'AUD',
		to_currency_name: 'Australian Dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'CAD',
		from_currency_name: 'Canadian Dollar',
		to_currency: 'CAD',
		to_currency_name: 'Canadian Dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'CHF',
		from_currency_name: 'Swiss Franc',
		to_currency: 'CHF',
		to_currency_name: 'Swiss Franc',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'CZK',
		from_currency_name: 'Czech koruna',
		to_currency: 'CZK',
		to_currency_name: 'Czech koruna',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'DKK',
		from_currency_name: 'Danish krone',
		to_currency: 'DKK',
		to_currency_name: 'Danish krone',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'AED',
		to_currency_name: 'United Arab Emirates dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'AUD',
		to_currency_name: 'Australian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'CAD',
		to_currency_name: 'Canadian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'CHF',
		to_currency_name: 'Swiss Franc',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'CNY',
		to_currency_name: 'Chinese Offshore',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'CZK',
		to_currency_name: 'Czech koruna',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'DKK',
		to_currency_name: 'Danish krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'EUR',
		to_currency_name: 'Euro',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'GBP',
		to_currency_name: 'Pound sterling',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'HKD',
		to_currency_name: 'Hong Kong Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'JPY',
		to_currency_name: 'Japanese Yen',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'NOK',
		to_currency_name: 'Norwegian krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'NZD',
		to_currency_name: 'New Zealand dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'PLN',
		to_currency_name: 'Polish zloty',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'SEK',
		to_currency_name: 'Swedish krona',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'SGD',
		to_currency_name: 'Singapore dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'USD',
		to_currency_name: 'US Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'ZAR',
		to_currency_name: 'South African rand',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'BGN',
		to_currency_name: 'Bulgarian lev',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'BHD',
		to_currency_name: 'Bahraini dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'HUF',
		to_currency_name: 'Hungarian forint',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'ILS',
		to_currency_name: 'Israeli new shekel',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'INR',
		to_currency_name: 'Indian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'KWD',
		to_currency_name: 'Kuwaiti dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'MAD',
		to_currency_name: 'Moroccan dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'MUR',
		to_currency_name: 'Mauritian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'RON',
		to_currency_name: 'Romanian leu',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'SAR',
		to_currency_name: 'Saudi riyal',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'EUR',
		from_currency_name: 'Euro',
		to_currency: 'THB',
		to_currency_name: 'Thai baht',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'HKD',
		from_currency_name: 'Hong Kong Dollar',
		to_currency: 'HKD',
		to_currency_name: 'Hong Kong Dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'JPY',
		from_currency_name: 'Japanese Yen',
		to_currency: 'JPY',
		to_currency_name: 'Japanese Yen',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'NOK',
		from_currency_name: 'Norwegian krone',
		to_currency: 'NOK',
		to_currency_name: 'Norwegian krone',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'NZD',
		from_currency_name: 'New Zealand dollar',
		to_currency: 'NZD',
		to_currency_name: 'New Zealand dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'PLN',
		from_currency_name: 'Polish zloty',
		to_currency: 'PLN',
		to_currency_name: 'Polish zloty',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'SEK',
		from_currency_name: 'Swedish krona',
		to_currency: 'SEK',
		to_currency_name: 'Swedish krona',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'SGD',
		from_currency_name: 'Singapore dollar',
		to_currency: 'SGD',
		to_currency_name: 'Singapore dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'AED',
		to_currency_name: 'United Arab Emirates dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'AUD',
		to_currency_name: 'Australian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'CAD',
		to_currency_name: 'Canadian Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'CHF',
		to_currency_name: 'Swiss Franc',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'CNY',
		to_currency_name: 'Chinese Offshore',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'CZK',
		to_currency_name: 'Czech koruna',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'DKK',
		to_currency_name: 'Danish krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'EUR',
		to_currency_name: 'Euro',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'GBP',
		to_currency_name: 'Pound sterling',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'HKD',
		to_currency_name: 'Hong Kong Dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'JPY',
		to_currency_name: 'Japanese Yen',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'NOK',
		to_currency_name: 'Norwegian krone',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'NZD',
		to_currency_name: 'New Zealand dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'PLN',
		to_currency_name: 'Polish zloty',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'SEK',
		to_currency_name: 'Swedish krona',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'SGD',
		to_currency_name: 'Singapore dollar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'USD',
		to_currency_name: 'US Dollar',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'ZAR',
		to_currency_name: 'South African rand',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'BGN',
		to_currency_name: 'Bulgarian lev',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'BHD',
		to_currency_name: 'Bahraini dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'HUF',
		to_currency_name: 'Hungarian forint',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'ILS',
		to_currency_name: 'Israeli new shekel',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'INR',
		to_currency_name: 'Indian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'KWD',
		to_currency_name: 'Kuwaiti dinar',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'MAD',
		to_currency_name: 'Moroccan dirham',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'MUR',
		to_currency_name: 'Mauritian rupee',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'RON',
		to_currency_name: 'Romanian leu',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'SAR',
		to_currency_name: 'Saudi riyal',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'Y',
	},
	{
		from_currency: 'USD',
		from_currency_name: 'US Dollar',
		to_currency: 'THB',
		to_currency_name: 'Thai baht',
		live_fx_rate_available: 'Y',
		pre_booked_rate_mandatory: 'N',
	},
	{
		from_currency: 'ZAR',
		from_currency_name: 'South African rand',
		to_currency: 'ZAR',
		to_currency_name: 'South African rand',
		live_fx_rate_available: 'N',
		pre_booked_rate_mandatory: 'N',
	},
];
